<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div>
      <div class="head-profile-modal-list">
        <h2>Histórico de dispensação:</h2>
      </div>
      @if (listPrescriptionMedicineCheckStruct && listPrescriptionMedicineCheckStruct.length > 0) {
        @for (item of listPrescriptionMedicineCheckStruct; track item) {
          <div class="row">
            <div class="col-md-12">
              @if (item.prescriptionMedicineCheck.datetimeCheckFulfilled) {
                <label>
                  Checado
                </label>
              }
              @if (!item.prescriptionMedicineCheck.datetimeCheckFulfilled) {
                <label>
                  Pendente
                </label>
              }
                        <p [ngClass]="{'early-green': item.prescriptionStatus == 2,
                            'near-yellow': item.prescriptionStatus == 1,
                            'late-red': item.prescriptionStatus == 3}">
                {{item.prescriptionMedicineCheck.datetimeCheckEstimative | date:'dd/MM/yyyy HH:mm'}}
              </p>
            </div>
          </div>
        }
      }
      @if (listPrescriptionSolutionCheckStruct && listPrescriptionSolutionCheckStruct.length > 0) {
        @for (item of listPrescriptionSolutionCheckStruct; track item) {
          <div class="row">
            <div class="col-md-12">
              @if (item.prescriptionSolutionCheck.datetimeCheckFulfilled) {
                <label>
                  Checado
                </label>
              }
              @if (!item.prescriptionSolutionCheck.datetimeCheckFulfilled) {
                <label>
                  Pendente
                </label>
              }
                        <p [ngClass]="{'early-green': item.prescriptionStatus == 2,
                            'near-yellow': item.prescriptionStatus == 1,
                            'late-red': item.prescriptionStatus == 3}">
                {{item.prescriptionSolutionCheck.datetimeCheckEstimative | date:'dd/MM/yyyy HH:mm'}}
              </p>
            </div>
          </div>
        }
      }
      @if ((!listPrescriptionMedicineCheckStruct || listPrescriptionMedicineCheckStruct.length == 0) && (!listPrescriptionSolutionCheckStruct || listPrescriptionSolutionCheckStruct.length == 0)) {
        <app-empty-list
          [message]="'Não há histórico de dispensação'">
        </app-empty-list>
      }
    </div>
    <div class="footer-modal-list">
      <button mat-flat-button type="button" color="accent" class="btn-block"
        (click)="close()"><span>Voltar</span></button>
      </div>
    </div>
  </div>